import { ref } from 'firebase/storage';
import { storage } from './init';

export const getStorageRef = (path: string) => {
  return ref(storage, path);
};
